import { render, staticRenderFns } from "./leaveMessage.vue?vue&type=template&id=df7ac984&scoped=true"
import script from "./leaveMessage.vue?vue&type=script&lang=js"
export * from "./leaveMessage.vue?vue&type=script&lang=js"
import style0 from "./leaveMessage.vue?vue&type=style&index=0&id=df7ac984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7ac984",
  null
  
)

export default component.exports